import React from "react";
import Badge from "@surgia/ui/components/badge";
import ProductIcon from "@surgia/ui/icons/catalog/parentProduct.svg";
import { ProductHeaderProps } from "./types";

/**
 * Header component for displaying product basic information and status
 */
const ProductHeader: React.FC<ProductHeaderProps> = ({
  productName,
  productImage,
  isParent = false,
  isExpanded,
  customerView,
  isCustomerViewDisabled,
  isProductDetailsPage,
  onToggleExpansion,
}) => {
  return (
    <div
      className="px-6 py-4 flex items-center justify-between cursor-pointer hover:bg-gray-50"
      onClick={onToggleExpansion}
    >
      <div className="flex items-center gap-3">
        <img
          src={productImage ?? ProductIcon}
          alt="product"
          className="rounded-full w-[40px] h-[40px]"
        />
        <div>
          <h3 className="text-gray-900 font-medium">{productName}</h3>
          <p className="text-sm text-gray-500">
            {isParent ? "Parent Product" : "Variant"}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {!isProductDetailsPage && (
          <Badge
            variant={isCustomerViewDisabled ? "default" : "active"}
            className="!rounded-lg"
          >
            {isCustomerViewDisabled ? "Draft" : "Completed"}
          </Badge>
        )}

        {isProductDetailsPage && (
          <Badge
            variant={!customerView ? "default" : "active"}
            className="!rounded-lg"
          >
            {!customerView ? "Draft" : "Published"}
          </Badge>
        )}
        <svg
          className={`w-4 h-4 text-gray-400 transition-transform ${
            isExpanded ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </div>
  );
};

export default ProductHeader;
